"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MOBILE_GAP = exports.DESKTOP_GAP = exports.CATEGORIES_SECTION = void 0;
const CATEGORIES_SECTION = exports.CATEGORIES_SECTION = 'categories-section';
const DESKTOP_GAP = exports.DESKTOP_GAP = 20;
const MOBILE_GAP = exports.MOBILE_GAP = 15;
